import * as moment from "moment";
import { get } from "lodash";
import { IncomeEnum, IncomePhaseEnum } from "../enum/income.enum";
import * as Bowser from "bowser";

export function removeNonDigit(value: string): string {
    value = value || "";
    return value.replace(/\D/g, "");
}

export function removeParentheses(value) {
    if (value) {
        return value.replace(/[()]/g, "");
    } else {
        return value;
    }
}
export function removeAccent(word: string): string {
    word = word.toLowerCase();
    word = word.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
    word = word.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
    word = word.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
    word = word.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
    word = word.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
    word = word.replace(new RegExp("[Ç]", "gi"), "c");
    return word;
}

export function removeAccents(accentedWord: string) {
    if (!accentedWord) {
        return;
    }
    let input = accentedWord.toString().toLowerCase();
    const accentedMapHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g,
    };

    for (const letter of Object.keys(accentedMapHex)) {
        const regex = accentedMapHex[letter];
        input = input.replace(regex, letter);
    }
    return input;
}

export function removeAccentsAndReplaceSpace(word) {
    if (word) {
        const formatedWord = removeAccent(word);
        return formatedWord.replace(/\s/g, "-");
    }
}
/**
 * Recebe uma string no formato dd/mm/yyyy e converte para date
 *
 * @type {Date}
 */
export function parseStringToDate(dateString: string): Date {
    const str = dateString.split("/").reverse().join("-"),
        date = moment(str);
    return date.isValid() ? date.toDate() : null;
}

/**
 * Recebe uma string no formato dd/mm/yyyy e converte para date
 *
 * @type {Date}
 */
export function sortAlphabeticaly(list: any[], key: string): any[] {
    const result: any[] = list ? list : [];
    return result.sort((a, b) => {
        if (a[key] < b[key]) {
            return -1;
        }
        if (a[key] > b[key]) {
            return 1;
        }
        return 0;
    });
}

export function getIncome(income) {
    income = Number(income);
    if (income >= IncomeEnum.DEZMIL) {
        return IncomePhaseEnum.FAIXA_6;
    } else if (income >= IncomeEnum.SETEMIL && income <= IncomeEnum.NOVEMIL) {
        return IncomePhaseEnum.FAIXA_5;
    } else if (income >= IncomeEnum.QUATROMIL && income <= IncomeEnum.SEISMIL) {
        return IncomePhaseEnum.FAIXA_4;
    } else if (
        income >= IncomeEnum.MILDUZENTOS &&
        income <= IncomeEnum.TRESMIL
    ) {
        return IncomePhaseEnum.FAIXA_3;
    } else if (
        income >= IncomeEnum.QUINHENTOS &&
        income <= IncomeEnum.MILECEM
    ) {
        return IncomePhaseEnum.FAIXA_2;
    } else {
        return IncomePhaseEnum.FAIXA_1;
    }
}

/**
 * Objeto com métodos rápidos para identificar dispositivo
 */
export const device = {
mobile() {
    const parser = Bowser.getParser(window.navigator.userAgent);
    return parser.getPlatformType() === "mobile";
},
    desktop() {
        const parser = Bowser.getParser(window.navigator.userAgent);
        return parser.getPlatformType() === "desktop";
    },
    type() {
        const parser = Bowser.getParser(window.navigator.userAgent);
        return parser.getPlatformType() === "mobile" ? "mobile" : "webdesktop";
    },
    ios() {
        const parser = Bowser.getParser(window.navigator.userAgent);
        return parser.getOSName(true) === "ios";
    },
    chrome() {
        const parser = Bowser.getParser(window.navigator.userAgent);
        return parser.getBrowserName(true) === "chrome" || parser.getBrowserName(true) === "chromium";
    },
    safari() {
        const parser = Bowser.getParser(window.navigator.userAgent);
        return parser.getBrowserName(true) === "safari";
    },
    msie() {
        const re = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
        return re.exec(window.navigator.userAgent) != null;
    },
    windows() {
        const parser = Bowser.getParser(window.navigator.userAgent);
        return parser.getOSName(true) === "windows";
    },
    platform() {
        const parser = Bowser.getParser(window.navigator.userAgent);
        return parser.getOSName();
    },
};

export const formatPhone = (str: string): string => {
    const dddLastCharPosition = 2;
    const dddFirstDigitPosition = 0;
    const phoneFirstPartLastPosition = 3;
    const phoneFirstPartFisrtDigitPosition = 3;
    const phoneSecondPartFirstDigitPosition = 4;

    const code = str.substr(dddFirstDigitPosition, dddLastCharPosition);
    const phone = str.substr(
        phoneFirstPartFisrtDigitPosition,
        str.length - phoneFirstPartLastPosition
    );

    return `(${code})****-${phone.substr(
        phoneSecondPartFirstDigitPosition,
        str.length
    )}`;
};

export const formatAccountNumber = (
    accountNumber: string,
    sizeAccount: number,
    sizeDigit: number
) => {
    let cropped, _account, digit;

    if (accountNumber.length < sizeAccount + sizeDigit) {
        sizeAccount = accountNumber.length - sizeDigit;
    }

    cropped = accountNumber.substring(
        accountNumber.length - sizeAccount,
        accountNumber.length
    );
    _account = cropped.substring(0, sizeAccount - 1);

    digit = cropped.substring(cropped.length - 1 - sizeDigit, sizeDigit);

    return `${_account}-${digit}`;
};

export const formatGaValue = (value: string) => {
    if (!value) return;
    if (
        value === "GRATUITO" ||
        value === "Gratuito" ||
        value === "GRÁTIS" ||
        value === "Grátis"
    )
        return "0";
    let regex = /(\d+),/gm;
    let newValue = value.match(regex);
    return newValue[0].replace(",", "");
};

export const formatCardName = (cardName: string) => {
    if (!cardName) return;
    let newCardName = cardName.split("_");
    return newCardName[newCardName.length - 2] === "productCard"
        ? `${newCardName[newCardName.length - 1]}`
        : `${newCardName[newCardName.length - 2]} ${
              newCardName[newCardName.length - 1]
          }`;
};

export const decodeString = (value: string) => {
    if (!value) return;
    const parsed = new DOMParser().parseFromString(value, "text/html").body
        .innerText;
    return parsed;
};

export const clearHtmlTags = (html: string) => {
    if (!html) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }
